import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.message.send');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-message-send',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.message.send/view.scss */
/* src/app/portal.lpsysadmin.widget.message.send/view.scss: no such file or directory */`],
})
export class PortalLpsysadminWidgetMessageSendComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() user_id_list: any;
    @Input() event: any = {};

    public title: any = "";
    public content: any = "";
    public link: any = "";

    public async ngOnInit() {
        await this.service.init();
    }

    public async sendMessage() {
        if (this.title === "") {
            alert('제목을 입력해주세요.');
            return;
        }

        if (this.content === "") {
            alert('내용을 입력해주세요.');
            return;
        }

        const { code } = await wiz.call("send", {
            title: this.title,
            user_id_list: JSON.stringify(this.user_id_list),
            content: this.content,
            link: this.link
        });
        await this.event.close();
    }

    public async cancel() {
        await this.event.close();
    }
}

export default PortalLpsysadminWidgetMessageSendComponent;